"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommunityPoolAuditToJSON = exports.CommunityPoolAuditFromJSONTyped = exports.CommunityPoolAuditFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function CommunityPoolAuditFromJSON(json) {
    return CommunityPoolAuditFromJSONTyped(json, false);
}
exports.CommunityPoolAuditFromJSON = CommunityPoolAuditFromJSON;
function CommunityPoolAuditFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'action': (0, _1.CommunityPoolAuditActionFromJSON)(json['action']),
        'actor': json['actor'],
        'target': !(0, runtime_1.exists)(json, 'target') ? undefined : json['target'],
        'conversionId': !(0, runtime_1.exists)(json, 'conversionId') ? undefined : json['conversionId'],
        'changes': !(0, runtime_1.exists)(json, 'changes') ? undefined : json['changes'],
        'reason': !(0, runtime_1.exists)(json, 'reason') ? undefined : json['reason'],
    };
}
exports.CommunityPoolAuditFromJSONTyped = CommunityPoolAuditFromJSONTyped;
function CommunityPoolAuditToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
        'action': (0, _1.CommunityPoolAuditActionToJSON)(value.action),
        'actor': value.actor,
        'target': value.target,
        'conversionId': value.conversionId,
        'changes': value.changes,
        'reason': value.reason,
    };
}
exports.CommunityPoolAuditToJSON = CommunityPoolAuditToJSON;
